import { z } from 'zod';

export const roadmapReleaseStatusSchema = z.enum(['done', 'next']);

export const roadmapReleaseSchema = z.object({
  tag: z.string(),
  date: z.string(),
  status: roadmapReleaseStatusSchema,
  title: z.string(),
  summary: z.string(),
  highlights: z.array(z.string()),
});

export const roadmapSchema = z.object({
  releases: z.array(roadmapReleaseSchema),
});

export type RoadmapRelease = z.infer<typeof roadmapReleaseSchema>;
export type Roadmap = z.infer<typeof roadmapSchema>;
